module.exports = __webpack_public_path__ + "c4a0086675884b2ca4228e5d1cd9af0f.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/moonhouse.ttf
// module id = 10
// module chunks = 0